import { useCallback, useRef } from 'react';
import { useSSEConnection } from '../../../../hooks/useSSEConnection';
import { useOTCCheckDifferencesProgress } from '../../../../store/otcProgressStore';
import { CheckProgressEvent } from './types';

export const useOTCCheckDifferencesSSE = () => {
  const { updateFromEvent, complete: completeCheck } =
    useOTCCheckDifferencesProgress();
  const disconnectRef = useRef<(() => void) | null>(null);

  const handleMessage = useCallback(
    (data: CheckProgressEvent) => {
      updateFromEvent(data);

      if (data.type === 'complete') {
        completeCheck();
        disconnectRef.current?.();
      }
    },
    [updateFromEvent, completeCheck]
  );

  const { connect, disconnect } = useSSEConnection<CheckProgressEvent>(
    '/otc/check-differences-progress',
    { onMessage: handleMessage }
  );

  // Store disconnect ref for use in handleMessage
  disconnectRef.current = disconnect;

  return { connect, disconnect };
};
